<template>
	<div class="partner-kb-sponsor-item">
		<c-typography :type="isMobile ? 'caption2' : 'caption1'" color="gray600"> {{ role }} </c-typography>
		<c-divider class="partner-kb-sponsor-divider" vertical />
		<slot name="logo" />
	</div>
</template>

<script>
export default {
	name: 'PartnerKBSponsorItem',
	props: {
		role: {
			type: String,
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'resources/assets/scss/base/main';
.partner-kb-sponsor {
	&-item {
		@include flexbox();
		@include align-items(center);
		@include pc {
			height: 14px;
		}
		@include mobile {
			height: 11px;
		}
	}
	&-divider {
		height: 8px;
		@include pc {
			margin: 0 8px;
		}
		@include mobile {
			margin: 0 4px;
		}
	}
}
</style>
